export const BASE_URL = window.location.origin + "/participant-web-services/rest";
export const GET_ACCOUNT_SUMMARY = "/accounts/summary";
export const SERVER_ERROR = "Server Error !!  Try Later";
export const ROUTE_PLAN_MESSAGES = "/participant/accounts/#/plan-messages";
export const ROUTE_RETAIL_NOTIFICATIONS = "/participant/home/#/notifications";

export const PerformanceTrackingKeys = {
    PT_SIDEBAR_FIRST_LOAD: "pt-sidebar-first-load",
    PT_FIRST_LOAD: "pt-first-load",
    PT_SIGNIN_CLICKED: "pt-signin-clicked",
    PT_MFA_LOADED: "pt-mfa-loaded",
    PT_MFA_CLICKED: "pt-mfa-clicked",
    PT_RETIREMENT_SCORE_LOADED: "pt-retirement-score-loaded",
    PT_SIGNIN_MFA_DELTA: "pt-signin-mfa-delta",
    PT_GOAL_LOADED: "pt-goal-load",
    PT_GOAL_DELTA: "pt-goal-delta",
    PT_LOGIN_HELP_LOADED: "pt-login-help-loaded",
    PT_SIGNIN_LOGIN_HELP_DELTA: "pt-signin-login-help-delta"
};
